import {
  OPERATIONAL_ACCESS_ERROR,
  getOperationalAccessUserMessage,
} from '../constants/registrationState';

type ApiErrorPayload = {
  code?: unknown;
  error?: unknown;
  reason?: unknown;
  message?: unknown;
};

function isOperationalAccessErrorCode(
  code: unknown
): code is (typeof OPERATIONAL_ACCESS_ERROR)[keyof typeof OPERATIONAL_ACCESS_ERROR] {
  return (
    typeof code === 'string' &&
    Object.values(OPERATIONAL_ACCESS_ERROR).includes(
      code as (typeof OPERATIONAL_ACCESS_ERROR)[keyof typeof OPERATIONAL_ACCESS_ERROR]
    )
  );
}

/** Map backend 403 operational-access payload to user-facing copy (B2). */
export function mapOperationalAccessApiError(
  data: ApiErrorPayload | null | undefined,
  fallback = 'You do not have access to this feature yet.'
): string {
  if (!data) return fallback;
  const code = data.code ?? data.error;
  if (isOperationalAccessErrorCode(code)) {
    return getOperationalAccessUserMessage(code);
  }
  if (typeof data.reason === 'string' && data.reason.trim()) return data.reason;
  if (typeof data.message === 'string' && data.message.trim()) return data.message;
  return fallback;
}
